import notify from 'devextreme/ui/notify';

export const NotifyFailure = ({
  message = 'Failed to complete the operation.',
  displayTime = 7500,
  width = 450,
  outletContainer = '#outlet',
  position = { my: 'center top', at: 'center top', of: outletContainer },
} = {}) => {
  notify({
    message: message,
    type: 'error',
    displayTime: displayTime,
    position: position,
    width: width,
  });
};